import {memo} from 'react';
import {Card, CardBody, Typography} from "@material-tailwind/react";
import EmptyImage from "../../assets/icons/EmptyImage";

const DashboardCardSkeleton = () => {
    return (
        <Card className="bg-white dark:bg-blue-gray-900 animate-pulse">
            <CardBody>
                <Typography variant="h6" className={`mb-2 text-right text-gray-300 dark:text-gray-800`}>
                    <EmptyImage className={'text-gray-500 w-10 h-10 inline-block float-left'}/>
                    <Typography
                        as="div"
                        variant="small"
                        className="mb-4 h-3 w-16 inline-block rounded-full bg-gray-300"
                    >&nbsp;</Typography>
                </Typography>
                <div className="text-right text-sm font-bold"><Typography
                    as="span"
                    variant="small"
                    className="h-3 w-10 rounded-full bg-gray-300 dark:bg-gray-800 inline-block"
                >
                    &nbsp;
                </Typography></div>
            </CardBody>
        </Card>
    );
}

export default memo(DashboardCardSkeleton);

